import { css } from '@emotion/react'
import colors from '@sportninja/common/constants/appColors'

export const POPUP_CLASS = 'feed-target-audience-tree-popup'

export const treeNodeStyle = css`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0;
  min-height: 36px;
`

export const treeNodeImageStyle = css`
  width: 24px;
  height: 24px;
  border-radius: 4px;
  object-fit: cover;
  flex-shrink: 0;
  border: 1px solid ${colors.NEUTRAL_50};
  align-self: center;
`

export const treeNodeTextStyle = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  flex: 1;
`

export const treeNodeNameStyle = css`
  color: ${colors.WHITE};
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const treeNodeSubtitleStyle = css`
  font-size: 12px;
  font-weight: 400;
  line-height: 1;
  color: ${colors.NEUTRAL_50};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 2px;
`

export const categoryTitleStyle = css`
  color: ${colors.PRIMARY};
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`

export const popupGlobalStyles = css`
  .${POPUP_CLASS} {
    z-index: 10002 !important;

    &.ant-select-dropdown {
      background: ${colors.SECONDARY_300} !important;
      border: 1px solid ${colors.SECONDARY_100};
      border-radius: 8px;
      padding: 8px 4px;
    }

    .ant-select-tree {
      background: ${colors.SECONDARY_300} !important;
      color: ${colors.NEUTRAL_0};
    }

    .ant-select-tree-list-holder-inner {
      background: ${colors.SECONDARY_300} !important;
    }

    .ant-select-tree-treenode {
      padding: 0px !important;
      border-radius: 6px;
      background: transparent !important;

      &:hover {
        background: ${colors.SECONDARY_200} !important;
      }
    }

    .ant-select-tree-node-content-wrapper {
      background: transparent !important;

      &:hover {
        background: transparent !important;
      }

      &.ant-select-tree-node-selected {
        background: transparent !important;
      }
    }

    .ant-select-tree-switcher {
      color: ${colors.NEUTRAL_50};
      width: 16px !important;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .ant-select-tree-switcher-noop {
      width: 16px !important;
    }

    .ant-select-tree-indent {
      background: transparent !important;
    }

    .ant-select-tree-indent-unit {
      background: transparent !important;
      width: 12px !important;
    }
  }
`

export const treeSelectStyles = css`
  min-width: 200px;
  max-width: 500px;
  height: 40px !important;
  color: ${colors.WHITE};

  .ant-select-selector {
    background: transparent !important;
    border-radius: 8px !important;
    height: 40px !important;
  }

  .ant-select-selection-search-input {
    height: 38px !important;
    color: ${colors.WHITE} !important;
  }

  .ant-select-selection-item {
    font-size: 13px !important;
    line-height: 38px !important;
    color: ${colors.WHITE} !important;
  }

  .ant-select-selection-placeholder {
    line-height: 38px !important;
    font-size: 14px !important;
    color: ${colors.NEUTRAL_50} !important;
  }

  .ant-select-clear {
    color: ${colors.WHITE};
  }

  &.ant-select-disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`
